module.exports = __webpack_public_path__ + "static/media/tlc_games_logo.5f832ad6.svg";